import {ModuleWithProviders} from "@angular/core"
import {Routes, RouterModule} from '@angular/router';
import {ProdutosListComponent} from './list/produtos.list.component'
import {ProdutosEditorComponent} from './editor/produtos.editor.component'


export const routes: Routes = [
  {
    path: '', redirectTo: 'list', pathMatch: 'full'
  },
  {
    path: 'list',
    component:ProdutosListComponent,
  },
  {
    path: 'edit',
    component:ProdutosEditorComponent,
  },
  {
    path: 'edit/:id',
    component:ProdutosEditorComponent,
  }
];

export const routing = RouterModule.forChild(routes);
